module.exports = __webpack_public_path__ + "img/apple_logo.2d057c29.png";